import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";
import Title from "../../Title";
import styles from "../styles";
import { compose } from "recompose";
import { withFirebase } from "../../../Firebase";
import EquipmentEditor from "./EquipmentEditor";
import {
  Divider,
  Link,
  TextField,
  MenuItem,
  Typography,
} from "@material-ui/core";
import {
  getDocs,
  collection
} from "@firebase/firestore";

// The merchant enters it on Business Info. It is not sent to Paysafe, so the
// office sees it here and in the deployment forms.
export const shippingAddressText = application => {
  const prefix =
    application.shippingDifferent || application.shippingAddress1
      ? "shipping"
      : "business";
  const field = name => application[`${prefix}${name}`] || "";
  return [
    [field("Address1"), field("Address2")].filter(Boolean).join(", "),
    [field("City"), [field("State"), field("Zip")].filter(Boolean).join(" ")]
      .filter(Boolean)
      .join(", ")
  ]
    .filter(Boolean)
    .join("\n");
};

class Processing extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      salesReps: [],
      processors: []
    };
  }

  componentDidMount = async () => {
    const firestore = this.props.firebase.firestore;
    const salesRepsSnapshot = await getDocs(collection(firestore, "salesReps"));
    const salesRepsData = salesRepsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    const processorsSnapshot = await getDocs(collection(firestore, "processors"));
    const processorsData = processorsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    this.setState({ salesReps: salesRepsData, processors: processorsData });
  };

  renderSalesRepOptions = (office) => {
    return this.state.salesReps
    .filter(rep => rep.office.includes(office))
    .sort((a, b) => a.code.localeCompare(b.code))
    .map((rep) => (
      <MenuItem key={rep.code} value={rep.id}>
        {rep.name} - {rep.code}
      </MenuItem>
    ));
  };  
  
  renderProcessorsOptions = () => {
    return this.state.processors.map((processor) => (
      <MenuItem key={processor.code} value={processor.code}>
        {processor.name}
      </MenuItem>
    ));
  };

  renderOfficeOptions = () => {
    const offices = Array.from(new Set(this.state.salesReps.flatMap(rep => rep.office)))
      .sort((a, b) => a.localeCompare(b));
    return offices.map(office => (
      <MenuItem key={office} value={office}>
        {office}
      </MenuItem>
    ));
  };  

  renderEquipmentSummary = () => {
    const {
      application,
      shopOrderItems = [],
      shopOrderItemsLoading,
      classes,
      equipmentInventory,
      equipmentInventoryLoading,
      defaultEquipment,
      defaultProcessor,
      onEquipmentChange,
      errors
    } = this.props;

    const equipment = Array.isArray(application.link?.equipment)
      ? application.link.equipment
      : [];

    return (
      <div className={classes.storeOrderSummary}>
        <EquipmentEditor
          equipment={equipment}
          inventory={equipmentInventory}
          inventoryLoading={equipmentInventoryLoading}
          defaultEquipment={defaultEquipment}
          defaultProcessor={defaultProcessor}
          useDefaultWhenEmpty={!Array.isArray(application.link?.equipment)}
          onChange={onEquipmentChange}
          error={errors?.equipment}
          classes={classes}
        />

        <Divider />
        <section className={classes.summarySection}>
          <Typography
            component="h2"
            variant="subtitle2"
            className={classes.summaryHeading}
          >
            Equipment shipping address
          </Typography>
          <Typography variant="body2" className={classes.shippingAddress}>
            {shippingAddressText(application)}
          </Typography>
          {!application.shippingDifferent && (
            <Typography variant="caption" color="textSecondary">
              Same as business address
            </Typography>
          )}
        </section>

        {application.storeId && (
          <>
            <Divider />

            <section className={classes.summarySection}>
              <Typography
                component="h2"
                variant="subtitle2"
                className={classes.summaryHeading}
              >
                Shop order items
              </Typography>
              {shopOrderItemsLoading ? (
                <Typography variant="body2" color="textSecondary">
                  Loading order items…
                </Typography>
              ) : shopOrderItems.length ? (
                <ul className={classes.summaryList}>
                  {shopOrderItems.map(item => (
                    <li key={item.id} className={classes.summaryItem}>
                      {item.permalink ? (
                        <Link
                          href={item.permalink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={classes.summaryLink}
                        >
                          {item.name} × {item.quantity}
                        </Link>
                      ) : (
                        <Typography variant="body2">
                          {item.name} × {item.quantity}
                        </Typography>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No shop order items found.
                </Typography>
              )}
            </section>
          </>
        )}
      </div>
    );
  };

  render() {
    const {
      application,
      onApplicationTextChange,
      errors,
      classes
    } = this.props;
    return (
      <div className={classes.root}>
        <Title
          h1={"Processing information"}
        />
        <div className={classes.sectionForm}>
          <div className={classes.inputContainer}>

          <TextField
              id="processor"
              label="Processor"
              variant="outlined"
              placeholder="Choose payment processor"
              className={classes.sideMargins}
              value={application.processor || ""}
              onChange={onApplicationTextChange("processor")}
              error={!!errors.processor}
              helperText={errors.processor}
              margin="normal"
              select
              fullWidth
            >
              {this.renderProcessorsOptions()}
            </TextField>

            <TextField
              id="office"
              label="Office"
              variant="outlined"
              placeholder="Choose office number"
              className={classes.sideMargins}
              value={application.office || ""}
              onChange={onApplicationTextChange("office")}
              error={!!errors.office}
              helperText={errors.office}
              margin="normal"
              select
              fullWidth
            >
              {this.renderOfficeOptions()}
            </TextField>

            <TextField
              id="salesRepInfo"
              label="Sales Rep"
              placeholder="Choose sales rep"
              variant="outlined"
              className={classes.sideMargins}
              value={application.salesRepInfo || ""}
              onChange={onApplicationTextChange("salesRepInfo")}
              error={!!errors.salesRepInfo}
              helperText={errors.salesRepInfo}
              margin="normal"
              select
              fullWidth
            >
              {this.renderSalesRepOptions(application?.office)}
            </TextField>

          </div>
          {this.renderEquipmentSummary()}
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withFirebase
)(Processing);
